import React from 'react';
import executiveSearchImg from '../assets/pexels-mikhail-nilov-7988125executive-search.jpg';
import contractHireImg from '../assets/pexels-sora-shimazaki-5673488.jpg';
import directHireImg from '../assets/pexels-tima-miroshnichenko-5439470.jpg';

const WhatWeOffer = () => {
  const services = [
    {
      icon: "🔍",
      title: "Executive Search",
      description: "An organisation needs the correct leadership if it is to succeed. Unfortunately, it is difficult and frequently impossible to find leaders of such calibre. We have worked with clients in a variety of industries and assisted them in transforming and thriving thanks to our decades of executive search and recruitment experience.",
      image: executiveSearchImg
    },
    {
      icon: "📝",
      title: "Contract Hire",
      description: "Your company must be lean and agile to stay competitive. It must be able to quickly respond to new obstacles and seize new opportunities. To do that, a flexible approach to hiring is essential, with the proper personnel being found for certain projects or initiatives as needed.",
      image: contractHireImg
    },
    {
      icon: "💼",
      title: "Direct Hire",
      description: "In order to recognise and comprehend your demands, Adroitone's direct hire service makes use of the extensive knowledge and experience of our staff. We identify the ideal candidates whose talent and outlook coincide with your own, providing quick, efficient solutions for whatever recruitment needs.",
      image: directHireImg
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What We Offer
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            As a leading staffing firm, our goal is to transform an ordinary career into an extraordinary professional journey. 
            We are passionate about making lives better for the people and driving the industry forward.
          </p>
          <p className="text-lg text-gray-500 mt-4 max-w-3xl mx-auto">
            Our efficient recruiting process is powered by cutting-edge technology - matching exceptional people with exceptional opportunities.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="group bg-gray-50 rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-200">
              {/* Image */}
              <div className="h-48 relative overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="text-center text-white">
                    <div className="text-4xl mb-2">{service.icon}</div>
                    <p className="text-sm font-semibold">{service.title}</p>
                  </div>
                </div>
              </div>
              
              {/* Content */}
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="text-2xl mr-3">{service.icon}</div>
                  <h3 className="text-xl font-bold text-gray-900">{service.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeOffer;